import { gql } from '@apollo/client';

export const USER_ME = gql`
  query User {
    me {
      id
      name
      email
      created
      lastLogin
      invalidLoginAttempts
      accountState
      emailVerified
    }
  }
`;

export const USER_MY_PERMISSIONS = gql`
  query UserMyPermissions {
    myPermissions
  }
`;

export const USER_BY_ID = gql`
  query User($id: Int!) {
    user(id: $id) {
      id
      name
      email
      created
      lastLogin
      invalidLoginAttempts
      accountState
      emailVerified
      maintainAfterDataSync
      apiKeysEnabled
      locale
      phoneNumber
      type
    }
  }
`;

export const USER_LIST = gql`
  query Users($params: UsersRequestParams!) {
    users(params: $params) {
      results {
        id
        name
        email
        lastLogin
        accountState
        phoneNumber
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput) {
    createUser(data: $data) {
      id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($data: UpdateUserInput) {
    updateUser(data: $data)
  }
`;

export const LOCK_USER = gql`
  mutation LockUser($id: Int!) {
    lockUser(id: $id)
  }
`;

export const ACTIVATE_USER = gql`
  mutation ActivateUser($id: Int!) {
    activateUser(id: $id)
  }
`;

export const DEACTIVATE_USER = gql`
  mutation DeactivateUser($id: Int!) {
    deactivateUser(id: $id)
  }
`;

export const REVOKE_PERMISSION = gql`
  mutation RevokePermission($id: Int!, $permissionId: Int!) {
    revokePermission(id: $id, permissionId: $permissionId)
  }
`;

export const GRANT_PERMISSION = gql`
  mutation GrantPermission($id: Int!, $permission: String!, $organizationId: Int) {
    grantPermission(id: $id, permission: $permission, organizationId: $organizationId)
  }
`;

export const USER_PERMISSIONS = gql`
  query UserPermissions($id: Int!) {
    userPermissions(id: $id) {
      id
      role
      organization {
        id
        name
      }
    }
  }
`;

export const AVAILABLE_ROLES = gql`
  query UserAvailableRoles($id: Int!) {
    userAvailableRoles(id: $id) {
      roleId: id
      name
      description
      permissions
      userType
      permissionType
    }
  }
`;

export const ASSIGNED_ROLES = gql`
  query UserAssignedRoles($id: Int!) {
    userAssignedRoles(id: $id) {
      roleId: id
      name
      organization {
        id
        name
      }
    }
  }
`;

export const REVOKE_ROLE = gql`
  mutation RevokeRole($id: Int!, $roleId: Int!, $organizationId: Int) {
    revokeRole(id: $id, roleId: $roleId, organizationId: $organizationId)
  }
`;

export const GRANT_ROLE = gql`
  mutation GrantRole($id: Int!, $roleId: Int!, $organizationId: Int) {
    grantRole(id: $id, roleId: $roleId, organizationId: $organizationId)
  }
`;
